module.exports = __webpack_public_path__ + "img/zanorari11.ed701f13.jpg";